import * as preact from "preact";

import { type PreactPageProps } from "pages/PreactPage";

interface LanguageInfo {
  bookCount: number;
  english: string;
  frequencies?: boolean;
  name: string;
  speakingMode?: boolean;
}

interface LanguagesPageOptions {
  languages: LanguageInfo[];
}

export default class LanguagesPageView extends preact.Component<PreactPageProps> {
  render() {
    const options = this.props.options as LanguagesPageOptions;

    return (
      <>
        <h2 class="spacing">Language Info</h2>

        <p>
          Readlang supports the following {options.languages.length} languages.
        </p>

        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Word Frequencies</th>
              <th>Auto-Pronounce</th>
              <th>Publicly Shared Texts</th>
            </tr>
          </thead>
          <tbody>
            {options.languages.map((language) => (
              <tr key={language.name}>
                <td>
                  {language.english} ({language.name})
                </td>
                <td>{language.frequencies ? "Yes" : "-"}</td>
                <td>{language.speakingMode ? "Yes" : "-"}</td>
                <td>{language.bookCount}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p>
          Note that{" "}
          <a href="https://blog.readlang.com/2015/10/06/speaking-mode.html">
            Auto-Pronounce
          </a>{" "}
          refers to the pronunciation of words when you click to translate or
          when you practice them. This is not to be confused with{" "}
          <a href="https://blog.readlang.com/2023/09/28/read-aloud.html">
            Read Aloud
          </a>{" "}
          which reads entire texts, the availability of which depends on your
          plan, language, and, for browser voices, your specific device and
          browser. High quality Readlang voices are generated by Readlang, so
          they sound consistent across your devices.
        </p>
      </>
    );
  }
}
